import { AgentActivity } from '@/types/chat';

/**
 * Determines if an agent activity represents an internal workflow node
 * that should be hidden from the user interface.
 */
export function isInternalAgentActivity(activity: AgentActivity): boolean {
  const nodeData = activity.data?.raw?.data || activity.data;
  const nodeType = typeof nodeData?.node_type === 'string' ? nodeData.node_type : nodeData?.type;
  const nt = typeof nodeType === 'string' ? nodeType.toLowerCase() : '';

  const nodeTitle =
    (typeof nodeData?.node_title === 'string' && nodeData.node_title) ||
    (typeof nodeData?.title === 'string' && nodeData.title) ||
    (typeof activity.label === 'string' && activity.label) ||
    '';
  const title = nodeTitle.toLowerCase();

  // Skip internal workflow nodes
  if (
    title.includes('connection type decider') ||
    title.includes('variable assigner') ||
    title.includes('query username') ||
    title.includes('query connected_social_account_id') ||
    nt === 'router' ||
    nt === 'if-else' ||
    nt === 'branch' ||
    nt === 'start'
  ) {
    return true;
  }

  return false;
}

/**
 * Determines if an agent activity should be visible in the UI.
 * Filters out internal activities and unlabeled activities.
 */
export function isVisibleAgentActivity(activity: AgentActivity): boolean {
  // Skip internal nodes
  if (isInternalAgentActivity(activity)) {
    return false;
  }

  // Skip unlabeled activities
  if (!activity.label) {
    return false;
  }

  return true;
}
